import { render, staticRenderFns } from "./DefectiveGoods.vue?vue&type=template&id=4a095a58&scoped=true"
import script from "./DefectiveGoods.vue?vue&type=script&lang=js"
export * from "./DefectiveGoods.vue?vue&type=script&lang=js"
import style0 from "./DefectiveGoods.vue?vue&type=style&index=0&id=4a095a58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a095a58",
  null
  
)

export default component.exports